module.exports = __webpack_public_path__ + "img/chat-background.7b1d8e86.jpg";